import {listen} from "../../../../../../../../event-bus";

export default class ViewCartTotalInitAfter {
    /**
     * constructor
     * @param props
     */
    constructor(props) {
        listen('constructor_cart_total_init_after', (eventData) => {
            eventData.showOnPages.push('SpendRewardPointComponent')

        }, 'ViewCartTotalInitAfter');
    }
}



// WEBPACK FOOTER //
// ./src/extension/reward-points/observer/view/component/checkout/cart/cart-total/ViewCartTotalInitAfter.js